export const KEYWORD_SUGGESTIONS = [
  {
    id: "NFT",
    text: "NFT",
  },
  {
    id: "Front-end",
    text: "Front-end",
  },
  {
    id: "Back-end",
    text: "Back-end",
  },
  {
    id: "Fullstack",
    text: "Fullstack",
  },
  {
    id: "Blockchain",
    text: "Blockchain",
  },
  {
    id: "Web",
    text: "Web",
  },
  {
    id: "Mobile",
    text: "Mobile",
  },
  {
    id: "Desktop",
    text: "Desktop",
  },
  {
    id: "Game",
    text: "Game",
  },
  {
    id: "Design",
    text: "Design",
  },
  {
    id: "Ui",
    text: "Ui",
  },
  {
    id: "Ux",
    text: "Ux",
  },
  {
    id: "AI",
    text: "AI",
  },
  {
    id: "Ml",
    text: "Ml",
  },
  {
    id: "Dl",
    text: "Dl",
  },
  {
    id: "Data",
    text: "Data",
  },
  {
    id: "Science",
    text: "Science",
  },
  {
    id: "Research",
    text: "Research",
  },
  {
    id: "Open source",
    text: "Open source",
  },
  {
    id: "Open-Source",
    text: "Open-Source",
  },
  {
    id: "Html",
    text: "Html",
  },
  {
    id: "Css",
    text: "Css",
  },
  {
    id: "React",
    text: "React",
  },
  {
    id: "Js",
    text: "Js",
  },
  {
    id: "Javascript",
    text: "Javascript",
  },
  {
    id: "Next.js",
    text: "Next.js",
  },
  {
    id: "Node.js",
    text: "Node.js",
  },
  {
    id: "Tailwind",
    text: "Tailwind",
  },
];
